import Register from "../register/components/Register";

const index = () => {
  return <Register />;
};

export default index;
